import { Component, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { routes } from 'src/app/shared/routes/routes';
import { SideBarService } from 'src/app/shared/side-bar/side-bar.service';

import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, of, Subject, takeUntil, finalize, timeout } from 'rxjs';
import { BuscadorGlobalService } from 'src/app/shared/services/buscador-global.service';
import { NotificacionesService } from 'src/app/shared/services/notificaciones.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  public routes = routes;
  public openBox = false;
  public mobileSearchOpen = false;
  public miniSidebar = false;
  public user: any;
  public puedeVerSettings: boolean = false;

  public searchControl = new FormControl('');
  public resultadosGlobales: any[] = [];
  public buscandoGlobal: boolean = false;

  //notificaciones del menu
  public notificaciones: any[] = [];
  public noLeidas: number = 0;
  private _notiInterval: any;
  private readonly notiDestroy$ = new Subject<void>();
  public notificacionesError = '';
  public notificacionesCargando = false;


  constructor(public router: Router, private sideBar: SideBarService, public auth: AuthService, private buscadorGlobalService: BuscadorGlobalService,
    public notificacionesService: NotificacionesService
  ) {
    this.sideBar.toggleSideBar.subscribe((res: string) => {
      if (res == 'true') {
        this.miniSidebar = true;
      } else {
        this.miniSidebar = false;
      }
    });
    let USER = localStorage.getItem("user");
    this.user = JSON.parse(USER ? USER : '');
    // console.log(this.user);

    // Mostrar opción Configuración solo a Super-Admin o a quienes tengan el permiso 'settings'
    if (this.user && this.user.roles && this.user.roles.includes('Super-Admin')) {
      this.puedeVerSettings = true;
    } else if (this.user && Array.isArray(this.user.permissions)) {
      this.puedeVerSettings = this.user.permissions.includes('settings');
    }


  }
  ngOnInit(): void {
    this.cargarNotificaciones();
    this._notiInterval = setInterval(() => this.cargarNotificaciones(), 30000);

    this.searchControl.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap((texto: any) => {
          if (!texto || texto.trim().length < 2) {
            this.resultadosGlobales = [];
            this.buscandoGlobal = false;
            return of({ resultados: [] });
          }

          this.buscandoGlobal = true;
          return this.buscadorGlobalService.buscar(texto);
        })
      )
      .subscribe({
        next: (resp: any) => {
          this.resultadosGlobales = resp.resultados ?? [];
          this.buscandoGlobal = false;
        },
        error: (error) => {
          // console.log(error);
          this.resultadosGlobales = [];
          this.buscandoGlobal = false;
        }
      });
  }

  cargarNotificaciones() {
    if (this.notificacionesCargando || !this.auth.token || document.hidden) return;
    if (!navigator.onLine) {
      this.notificacionesError = 'Sin conexión. Reintentaremos al recuperar la conexión.';
      return;
    }
    this.notificacionesCargando = true;
    this.notificacionesService.listar({ leida: 0, per_page: 20 }).pipe(
      timeout(15000),
      takeUntil(this.notiDestroy$),
      finalize(() => this.notificacionesCargando = false)
    ).subscribe({
      next: (resp: any) => {
        this.notificaciones = resp.notificaciones?.data ?? [];
        this.noLeidas = resp.unread_count ?? this.noLeidas;
        this.notificacionesError = '';
      },
      error: (error: any) => {
        this.notificacionesError = error?.status === 401
          ? 'Tu sesión expiró. Inicia sesión nuevamente.'
          : 'No se pudieron actualizar las notificaciones. Se reintentará automáticamente.';
      }
    });
  }
  /*marcarLeida(item: any) {
    if (item.leida) return;

    this.notificacionesService.marcarLeida(item.id_notificacion).subscribe({
      next: () => {
        item.leida = true;
        this.noLeidas = Math.max(0, this.noLeidas - 1);
      },
      error: (e) => console.log(e)
    });
  }*/
  marcarLeida(item: any){
    if (item.leida) return;
    this.notificacionesService.marcarLeida(item.id_notificacion).subscribe({
      next: () => {
        this.notificaciones = this.notificaciones.filter((n: any) => n.id_notificacion !== item.id_notificacion);
        this.noLeidas = Math.max(0, this.noLeidas - 1);
      },
      error: () => { this.notificacionesError = 'No se pudo completar la acción. Inténtalo nuevamente.'; }
    });
  }
 
  
  marcarTodasComoLeidas() {
    if (this.notificaciones.length === 0) return;
    this.notificacionesService.marcarTodasLeidas().subscribe({
      next: () => {
        this.notificaciones = [];
        this.noLeidas = 0;
      },
      error: () => { this.notificacionesError = 'No se pudo completar la acción. Inténtalo nuevamente.'; }
    });
  }
  // Confirmación por el modal
  borrarTodas() {
    if (this.notificaciones.length === 0) return;

    this.notificacionesService.borrarTodas().subscribe({
      next: () => {
        this.notificaciones = [];
        this.noLeidas = 0;
      },
      error: () => { this.notificacionesError = 'No se pudo completar la acción. Inténtalo nuevamente.'; }
    });
  }


  private rutasPorOrigen: Record<string, string> = {
    'viaticos':            routes.viaticosList,
    'gasto':               routes.viaticosList,
    'extraccion':          routes.insumosSolicitar,
    'servicio_vehicular':  routes.viaticosList,
    'servicios_vehicular': routes.listadoServicio,
    'reportes_diligencia': routes.diligenciaList,
    'reportes_comunicado': routes.comunicadoList,
    'reportes_sala':       routes.salaList,
    'reportes_grafico':    routes.ilustracionesList,
    'reporte_paqueteria':  routes.paqueteriaList,
    'reportes_sistemas':   routes.mantenimientoList,
    'reportes_permiso':    routes.permisosList,
    'reporte_reclutamiento': routes.reclutamientoList,
    'reporte_resguardo':   routes.todosInventario,
    // Igual que Comunicados: sin modal de detalle, solo navega a la lista.
    'reporte_politica':    routes.politicasList,
    'reporte_visitas':     routes.visitasList,
    'reportes_quejas_sugerencias': routes.quejasList,
    'reporte_incidencia':  routes.incidenciasList,
    'limite_retardo':        routes.retardosQuincena,
    'limite_retardo_propio': routes.adminDashboard,
    'baja_empleado': routes.bajaList,
    'proveedor': routes.proovedoresList,
    'suscripcion': routes.empresaList,
  };

  private paramKeyPorOrigen: Record<string, string> = {
    'viaticos':            'gastoId',
    'gasto':               'gastoId',
    'extraccion':          'insumoId',
    'servicio_vehicular':  'gastoId',
    'servicios_vehicular': 'id',
    'reportes_diligencia': 'diligenciaId',
    'reportes_sala':       'id',
    'reportes_grafico':    'ilustracionId',
    'reporte_paqueteria':  'paqueteriaId',
    'reportes_sistemas':   'ticketId',
    'reportes_permiso':    'permisoId',
    'reporte_reclutamiento': 'reclutamientoId',
    'reporte_resguardo':   'resguardoId',
    'reporte_visitas':     'visitaId',
    'reportes_quejas_sugerencias': 'quejaId',
    'reporte_incidencia':  'incidenciaId',
  };

  public puedeGestionarSala(): boolean {
    let currentUser = this.user;
    if (!currentUser) {
      const raw = localStorage.getItem('user');
      if (raw) {
        try { currentUser = JSON.parse(raw); } catch (e) { currentUser = null; }
      }
    }
    if (!currentUser) return false;

    const esRoot = currentUser.tipo_usuario === 'root' ||
      (Array.isArray(currentUser.roles) && currentUser.roles.some((r: any) => r === 'Super-Admin' || r?.name === 'Super-Admin'));
    if (esRoot) return true;

    if (Array.isArray(currentUser.permissions)) {
      return currentUser.permissions.some((p: any) => p === 'editar_sala' || p?.name === 'editar_sala');
    }
    return false;
  }

  navegarNotificacion(item: any) {
    this.marcarLeida(item);
    let ruta = this.rutasPorOrigen[item.origen_tipo];

    // Para notificaciones de sala de juntas:
    // Si el usuario cuenta con el permiso para gestionar reuniones ('editar_sala' o Super-Admin/root),
    // se le redirige a la sección de 'gestion-sala' donde podrá ingresar el link de videoconferencia (Meet, Zoom, etc.).
    // Si no cuenta con dicho permiso, se le redirige al listado regular de salas.
    if (item.origen_tipo === 'reportes_sala') {
      if (this.puedeGestionarSala()) {
        ruta = routes.salaGestion;
      } else {
        ruta = routes.salaList;
      }
    }

    if (ruta) {
      const paramKey = this.paramKeyPorOrigen[item.origen_tipo] ?? 'id';
      const extras = item.origen_id ? { queryParams: { [paramKey]: item.origen_id } } : {};
      this.router.navigate([ruta], extras);
    }
  }


  ngOnDestroy(): void {
    this.notiDestroy$.next();
    this.notiDestroy$.complete();
    clearInterval(this._notiInterval);
  }

  irAResultado(item: any) {
    if (!item?.clickable || !item?.ruta) {
      return;
    }

    this.router.navigate([item.ruta]);
    this.resultadosGlobales = [];
    this.mobileSearchOpen = false;
    this.searchControl.setValue('');
  }

  openBoxFunc() {
    this.openBox = !this.openBox;
    /* eslint no-var: off */
    var mainWrapper = document.getElementsByClassName('main-wrapper')[0];
    if (this.openBox) {
      mainWrapper.classList.add('open-msg-box');
    } else {
      mainWrapper.classList.remove('open-msg-box');
    }
  }

  logout() {
    this.auth.logout();
  }

  public toggleSideBar(): void {
    this.sideBar.switchSideMenuPosition();
  }
  public toggleMobileSideBar(): void {
    this.sideBar.switchMobileSideBarPosition();
  }

  @HostListener('document:keydown.escape')
  public closeMobileMenu(): void {
    this.sideBar.closeMobileSideBar();
  }

  @HostListener('window:resize')
  public onViewportResize(): void {
    if (window.innerWidth >= 992) this.sideBar.closeMobileSideBar();
  }
}
